export const LESION_FINDINGS = [
  'aneurysm',
  'abdominal_aortic_aneurysm',
  'ascending_aortic_aneurysm',
  'ascending_aortic_dilation',
  'descending_thoracic_aortic_aneurysm',
  'descending_thoracic_aortic_dilation',
  'indeterminant_nodule',
  'indeterminate_nodule',
  'indeterminate_lesion',
  'indeterminant_lesion',
  'cystic_lesion',
];
